<template>
    <div :id="'google-map-' + this._uid" class="google-map"></div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";
import GoogleMapInfoWindow from "./GoogleMapInfoWindow";
import Vue from "vue";
import SettingsMixin from "../../../mixins/SettingsMixin";
import ApiRequest from "../../../utils/api-request";

const mapStyles = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#7fb5a5"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#c2ddd6"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#649a8c"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#e9f1ee"
            },
            {
                "visibility": "on"
            }
        ]
    }
];

export default {
    name: "GoogleMap",
    mixins: [SettingsMixin],
    props: {
        zoom: {
            default: 13
        },
        disableDefaultUI: {
            type: Boolean,
            default: true
        },
        // centerDefaultLocation: {
        //     type: Boolean,
        //     default: true
        // }
    },
    data() {
        return {
            map: null,
            currentLocation: {},
            markers: [],
            infoWindows: []
        }
    },
    mounted() {
        this.initMapLoader().then(() => {
            this.initMap();
        });
    },
    methods: {
        // initializing Google Maps API JS Library
        async initMapLoader() {

            const loader = new Loader({
                apiKey: this.googleMapsApiKey,
                version: "weekly",
            });

            const location = new ApiRequest().getLocation(this.settings.locationId)

            await loader.load();
            await location.then(
                (response) => {
                    this.currentLocation = response.data;
                }
            );

        },
        // initializing Map instance
        initMap() {
            this.map = new google.maps.Map(document.getElementById('google-map-' + this._uid), {
                center: {
                    lat: parseFloat(this.currentLocation.lat),
                    lng: parseFloat(this.currentLocation.lng),
                },
                zoom: this.zoom,
                styles: mapStyles,
                clickableIcons: false,
                disableDefaultUI: this.disableDefaultUI
            });
            this.map.addListener('click', () => {
                this.infoWindows.forEach(iw => {
                    iw.close()
                });
            });
            this.$emit('ready');
        },
        resetMarkers() {
            this.markers.forEach(m => m.setMap(null));
            this.markers = [];
        },
        // add marker to the markers array
        addMarker(data) {

            try {
                const marker = new google.maps.Marker({
                    map: this.map,
                    position: data.position,
                    icon: '/assets/images/icons/map-marker.svg'
                });

                let infoWindow = new google.maps.InfoWindow({
                    content: this.getInfoWindowContent(data)
                })

                marker.addListener('click', (event) => {
                    event.domEvent.target.classList.add('marker-active');
                    this.infoWindows.forEach(iw => {
                        iw.close();
                    });
                    infoWindow.open({
                        anchor: marker
                    });
                });
                this.markers.push(marker);
                this.infoWindows.push(infoWindow);
            } catch (error) {
                console.error('Failed to create marker', error);
            }

        },
        getInfoWindowContent(data) {
            let InfoWindow = Vue.extend(GoogleMapInfoWindow);
            let instance = new InfoWindow({
                propsData: {
                    title: data.title,
                    image: data.logoUrl,
                    address: data.address,
                    phone: data.phone,
                }
            });
            return instance.$mount().$el;
        },
        moveCenter(lat, lng) {
            let newCenter = new google.maps.LatLng(lat, lng);
            this.map.panTo(newCenter);
            this.markers.forEach(m => {
                m.setIcon('/assets/images/icons/map-marker'+ ((m.position.lat() === parseFloat(lat) && m.position.lng() === parseFloat(lng)) ? '-active' : '' )+'.svg' )
            });
        }
    }
}
</script>

<style scoped>

</style>
